"use client"
import { BreadcrumbItem, Breadcrumbs, BreadcrumbsProps } from "@nextui-org/breadcrumbs"
import { LayoutGrid } from "lucide-react"


type RouteBreadcrumbsProps = { locale: string } & Omit<BreadcrumbsProps, "children">


export function ExploreBreadcrumbs(props: RouteBreadcrumbsProps & { name: string }) {

    return <Breadcrumbs underline="hover">
    <BreadcrumbItem href={"/"}>
      <LayoutGrid className="size-4" />
    </BreadcrumbItem>
    <BreadcrumbItem href={"/explore/index"}>探索与发现</BreadcrumbItem>
    <BreadcrumbItem>{props.name}</BreadcrumbItem>
  </Breadcrumbs>
}
